import React from "react";
import './Footer.scss';
import InstaIcon from '../../assets/svg/insta.svg';
import FaceIcon from '../../assets/svg/facebook.svg';
import LinkedIcon from '../../assets/svg/linked.svg';

const Footer: React.FC = () => {
    return (
        <footer>
            <div className="main-footer-content">
                <div className="farewell-div">
                    <h3 className="footer-title">Hvala Vam na poseti!</h3>
                    <p className="footer-text">Nadamo se da Vam je Best design Week i ove godine bio prijatno iskustvo!</p>
                </div>
                <div className="socials-div">
                    <h3 className="footer-title">Ostanimo u kontaktu!</h3>
                    <div className="footer-icons-row">
                        <a href="https://www.instagram.com/best_belgrade/" target="_blank" className="hover-it"><img src={InstaIcon} alt="Instagram icon" className="footer-icon"/></a>
                        <a href="https://www.facebook.com/best.beograd/" target="_blank" className="hover-it"><img src={FaceIcon} alt="Facebook icon" className="footer-icon"/></a>
                        <a href="https://www.linkedin.com/company/best-belgrade/" target="_blank" className="hover-it"><img src={LinkedIcon} alt="Linked icon" className="footer-icon"/></a>
                    </div>
                </div>
            </div>
            <div className="footer-credits-content">
                <p className="footer-credits-p">• BEST DESIGN WEEK Belgrade • 2026 • Site Responsible: <a href="https://www.linkedin.com/in/andrijana-stepanovic" className="footer-link">Andrijana Stepanović</a> • With ❤︎ for BEST!</p>
            </div>
        </footer>
    )
}

export default Footer;